var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEjipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#DCF1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6034 14.5156H11.3966C10.0729 14.5156 9 15.5886 9 16.9122V21.5041H41V16.9122C41 15.5886 39.9271 14.5156 38.6034 14.5156Z",
    fill: "#FF4B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 33.0841C9 34.4077 10.0729 35.4807 11.3966 35.4807H38.6034C39.927 35.4807 41 34.4078 41 33.0841V28.4922H9V33.0841Z",
    fill: "#464655"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.5039H41V28.492H9V21.5039Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7616 23.9075C26.7616 23.634 26.4935 23.4407 26.234 23.5273L25.7463 23.6898L25.6278 22.9747C25.5942 22.7686 25.4882 22.5813 25.3289 22.4464C25.1696 22.3114 24.9675 22.2377 24.7587 22.2383H24.3025L23.8254 22.8255H24.4572L24.2804 23.6988L23.7658 23.5273C23.5063 23.4407 23.2383 23.634 23.2383 23.9075V26.8747L23.9485 26.1645L23.6138 27.1683H23.2383V27.7556H26.7617V27.1683H26.3862L26.0515 26.1645L26.7617 26.8747V23.9075H26.7616ZM24.7064 27.1683H24.233L24.5585 26.299L24.7064 26.4878V27.1683ZM25.2935 27.1683V26.4878L25.4414 26.299L25.7669 27.1683H25.2935ZM25 26.104C25 26.104 24.0916 25.4892 24.1283 24.3423C24.1283 24.3423 24.6881 24.2506 25 23.7551C25.3119 24.2505 25.8717 24.3423 25.8717 24.3423C25.9083 25.4893 25 26.104 25 26.104Z",
    fill: "#F0C727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEjipt);
export default __webpack_public_path__ + "static/media/ejipt.56c14403d169865d6ab0db2787c7c5fa.svg";
export { ForwardRef as ReactComponent };